module.exports = "assets/img/Tracé 4.png";